// removed by extract-text-webpack-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","container":"container-2YMv_","number":"number-2bbh9","header":"header--wv0X","title":"title-8eqIb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_step.css
// module id = 1249
// module chunks = 1